import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import { pluginSettingsService } from '../services/api/plugin-settings-service.js';

export const shortcutsQueryOptions = () => ({
  queryKey: queryKeys.pluginSettings.shortcuts(),
  queryFn: ({ signal }) => pluginSettingsService.fetchShortcuts({ signal }),
  staleTime: 0,
  retry: false,
  refetchOnWindowFocus: false,
  meta: { persist: false },
});

/** The plugins the doctor chose as shortcuts: `{ pluginIds, saved }`. */
export function useShortcutsSettings() {
  return useQuery(shortcutsQueryOptions());
}

export function useSaveShortcuts() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (pluginIds) => pluginSettingsService.saveShortcuts(pluginIds),
    onSuccess: (data) => queryClient.setQueryData(queryKeys.pluginSettings.shortcuts(), data),
    meta: { persist: false },
  });
}
